import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import cacheManager from '../CacheManager';

const PgItens = () => {
  const [itens, setItens] = useState([]);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const itensPorPagina = 10;
  const [termoDeBusca, setTermoDeBusca] = useState('');
  const [itensFiltrados, setItensFiltrados] = useState([]);
  const [espacosById, setEspacosById] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const search = async () => {
    try {
      setIsLoading(true);
      const espacosById = await cacheManager.getEspacosById();
      setEspacosById(espacosById);
      const itensCache = await cacheManager.getItensCache()
      setItens(itensCache);
    } catch (error) {
      console.error('Erro ao buscar itens:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Estilos para esmaecer a página
  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 2, // Garanta que esteja acima de outros elementos da página
    display: isLoading ? 'block' : 'none', // Mostra apenas quando está carregando
};

  useEffect(() => {
    search(); // Chama a função search ao montar o componente
  }, []); // O array vazio como segundo argumento garante que o efeito seja executado apenas uma vez, na montagem do componente

useEffect(() => {
    const itensOrdenados = [...itens].sort((a, b) => {
      const tituloA = a.titulo.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
      const tituloB = b.titulo.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

      return tituloA.localeCompare(tituloB, 'pt-BR', { sensitivity: 'base' });
    });

    const itensFiltrados = itensOrdenados.filter(item => {
      const tituloItem = item.titulo.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
      return tituloItem.includes(termoDeBusca.toLowerCase());
    });

    setItensFiltrados(itensFiltrados);
    setPaginaAtual(1);
  }, [itens, termoDeBusca]);

const addItem = () => {
    navigate('/item/novo'); // Use navigate para ir para /item/novo
};

// Calcular o número total de páginas
const totalPaginas = Math.ceil(itensFiltrados.length / itensPorPagina);

// Obter os itens da página atual
const indexDoUltimoItem = paginaAtual * itensPorPagina;
const indexDoPrimeiroItem = indexDoUltimoItem - itensPorPagina;
const itensAtuais = itensFiltrados.slice(indexDoPrimeiroItem, indexDoUltimoItem);

// Funções para alterar a página
const irParaPagina = (numero) => {
  setPaginaAtual(numero);
};


  return (
    <div className="container mt-5">
      {isLoading && <div style={overlayStyle}></div>} {/* Overlay de carregamento */}
      <h2 className="mb-4">Itens</h2>
      <div className="input-group mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Buscar..."
          id="search-input"
          value={termoDeBusca}
          onChange={(e) => setTermoDeBusca(e.target.value)}
        />
        <button className="btn btn-outline-secondary" type="button" onClick={search}>Buscar</button>
      </div>
      <table className="table">
        <thead className="table-light">
          <tr>
            <th>Título</th>
            <th>Espaço</th>
            <th>Duração</th>
            <th>Preço</th>
            <th>Descrição</th>
            <th>Posição</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {itensAtuais.map((item, index) => (
            <tr key={index}>
              <td><Link to={`/item/editar/${item.id_item}`} className="text-dark underline-on-hover">{item.titulo}</Link></td>
              <td>{item.id_espaco != null ? espacosById[item.id_espaco].titulo : ''}</td>
              <td>{item.duracao != null ? Math.floor(item.duracao / 3600).toString().padStart(2, '0') + ':' + (Math.floor(item.duracao % 3600 / 60)).toString().padStart(2, '0') : ''}</td>
              <td>{item.preco !== null && item.preco !== undefined ? `R$ ${Number(item.preco).toFixed(2).replace('.', ',')}` : ''}</td>
              <td>{item.descricao.length > 40 ? item.descricao.substring(0, 40) + '...' : item.descricao}</td>
              <td>{item.posicao}</td>
              <td>
                <Link to={`/item/editar/${item.id_item}`} className="btn btn-primary btn-sm me-2">
                  <FontAwesomeIcon icon={faEdit} /> Editar
                </Link>
                <button className="btn btn-danger btn-sm" disabled>
                  <FontAwesomeIcon icon={faTrash} /> Excluir
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="d-flex justify-content-between align-items-center">
        <div>
          {/* Conteúdo da paginação */}
          <button onClick={() => irParaPagina(1)} disabled={paginaAtual === 1} className="btn btn-secondary" style={{ fontSize: '10px' }}>
            Primeira
          </button>
          {paginaAtual > 2 && (
            <button onClick={() => irParaPagina(paginaAtual - 2)} className="btn btn-secondary" style={{ fontSize: '10px' }}>
              {paginaAtual - 2}
            </button>
          )}
          {paginaAtual > 1 && (
            <button onClick={() => irParaPagina(paginaAtual - 1)} className="btn btn-secondary" style={{ fontSize: '10px' }}>
              {paginaAtual - 1}
            </button>
          )}
          <button className="btn btn-primary" style={{ fontSize: '10px' }}>
            {paginaAtual}
          </button>
          {paginaAtual < totalPaginas && (
            <button onClick={() => irParaPagina(paginaAtual + 1)} className="btn btn-secondary" style={{ fontSize: '10px' }}>
              {paginaAtual + 1}
            </button>
          )}
          {paginaAtual < totalPaginas - 1 && (
            <button onClick={() => irParaPagina(paginaAtual + 2)} className="btn btn-secondary" style={{ fontSize: '10px' }}>
              {paginaAtual + 2}
            </button>
          )}
          <button onClick={() => irParaPagina(totalPaginas)} disabled={paginaAtual === totalPaginas} className="btn btn-secondary" style={{ fontSize: '10px' }}>
            Última
          </button>
        </div>
        <div>
          <button type="button" className="btn btn-primary" onClick={addItem}>Incluir</button>
        </div>
      </div>
    </div>
  );
};

export default PgItens;